export default (element: HTMLElement) => {
    const top = Math.max(
        element.scrollHeight,
        element.offsetHeight,
        element.clientHeight
    );
    element.scrollTo({ top });
};
